import { render, staticRenderFns } from "./cameraIndex.vue?vue&type=template&id=48d1baca&scoped=true"
import script from "./cameraIndex.vue?vue&type=script&lang=js"
export * from "./cameraIndex.vue?vue&type=script&lang=js"
import style0 from "./cameraIndex.vue?vue&type=style&index=0&id=48d1baca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d1baca",
  null
  
)

export default component.exports